// // src/Components/Visitors/SecurityGatePanel.jsx
// import React, { useMemo, useState } from "react";
// import {
//   Alert,
//   Button,
//   Col,
//   Form,
//   Row,
//   Spinner,
//   Table,
//   Badge,
// } from "react-bootstrap";
// import {
//   useVisitorRequests,
//   useVisitorActions,
// } from "../../hooks/useVisitorRequests";
// import { useUploadSelfie } from "../../hooks/useVisitorUploadSelfie";
// import { serverTimestamp } from "firebase/firestore";
// // import QrReader from "react-qr-reader";
// import { QrReader } from "react-qr-reader";

// const STATUS_BADGE = {
//   preapproved: "info",
//   pending: "secondary",
//   approved: "success",
//   rejected: "danger",
//   entered: "primary",
//   exit_requested: "warning",
//   exited: "dark",
// };

// export default function SecurityGatePanel({ community, currentUser }) {
//   const { rows, loading, err } = useVisitorRequests({
//     communityId: community.id,
//     statusIn: ["pending", "approved", "entered", "exit_requested"],
//   });
//   const { createRequest, updateRequest, getById } = useVisitorActions();
//   const { uploadSelfie, uploading } = useUploadSelfie();

//   // New entry form (manual by security)
//   const [form, setForm] = useState({
//     flatLabel: "",
//     visitorType: "delivery",
//     visitorName: "",
//     phone: "",
//     vehicle: "",
//     purpose: "",
//     selfieFile: null,
//   });
//   const [submitting, setSubmitting] = useState(false);
//   const [scanOpen, setScanOpen] = useState(false);
//   const [scanError, setScanError] = useState("");

//   const onCreate = async () => {
//     if (!form.flatLabel || !form.visitorName) {
//       alert("Flat and Visitor Name are required");
//       return;
//     }
//     setSubmitting(true);
//     try {
//       // Find residentUid by flatLabel from community blocks if available
//       // If not available, you can store a mapping on community doc or a flats collection.
//       // For demo, residentUid is unknown unless you implement mapping:
//       const residentUid = ""; // TODO: resolve based on your data

//       const id = await createRequest({
//         communityId: community.id,
//         flatLabel: form.flatLabel.trim(),
//         visitorType: form.visitorType,
//         visitorName: form.visitorName.trim(),
//         phone: form.phone.trim(),
//         vehicle: form.vehicle.trim(),
//         purpose: form.purpose.trim(),
//         createdBy: {
//           uid: currentUser?.uid || null,
//           role: "security",
//           method: "security-form",
//         },
//         status: "pending",
//         approval: { requestedAt: serverTimestamp() },
//       });

//       // Upload selfie if any
//       let selfieUrl = null;
//       if (form.selfieFile) {
//         selfieUrl = await uploadSelfie(form.selfieFile, id);
//       }
//       if (selfieUrl) {
//         await updateRequest(id, { selfieUrl });
//       }

//       setForm({
//         flatLabel: "",
//         visitorType: "delivery",
//         visitorName: "",
//         phone: "",
//         vehicle: "",
//         purpose: "",
//         selfieFile: null,
//       });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   // Status transitions
//   const markEntered = async (id) => {
//     await updateRequest(id, {
//       status: "entered",
//       "gate.entryAt": serverTimestamp(),
//       "gate.entryBy": currentUser?.uid || null,
//     });
//   };
//   const requestExit = async (id) => {
//     await updateRequest(id, {
//       status: "exit_requested",
//       "gate.exitRequestedAt": serverTimestamp(),
//       "gate.exitRequestedBy": currentUser?.uid || null,
//     });
//   };
//   const markExited = async (id) => {
//     await updateRequest(id, {
//       status: "exited",
//       "gate.exitApprovedAt": serverTimestamp(),
//       "gate.exitApprovedBy": currentUser?.uid || null,
//     });
//   };

//   // QR scanning (read token, fetch pass, show details)
//   const onScan = async (value) => {
//     if (!value) return;
//     try {
//       setScanError("");
//       // We expect value to be something like: https://app/visit/{token} or JSON with token
//       const token = extractToken(value);
//       if (!token) {
//         setScanError("Invalid QR");
//         return;
//       }

//       // Option A: You store docId in token: docId|nonce
//       // Option B: You store a token in the doc (qrToken)
//       // Here we demonstrate looking up by token:
//       // For simplicity: add a callable endpoint or keep a tiny sub-collection mapping token->docId
//       // In UI-only demo we cannot query by token without index. Recommend you create index on qrToken.
//       // Example: useVisitorRequests hook variant or direct query by where('qrToken','==',token)
//       // For brevity, skip fetch-by-token demo code block here.

//       alert(
//         "Scanned! Token read. You should implement lookup by qrToken and show details."
//       );
//       setScanOpen(false);
//     } catch (e) {
//       setScanError(e?.message || "Scan failed");
//     }
//   };

//   const extractToken = (str) => {
//     try {
//       if (str.includes("/visit/")) {
//         return str.split("/visit/")[1].split(/[?#]/)[0];
//       }
//       // or direct token
//       if (str.startsWith("VT-")) return str;
//       return "";
//     } catch {
//       return "";
//     }
//   };

//   return (
//     <>
//       <h5 className="mb-3">Security Gate</h5>

//       <Row className="g-2 align-items-end">
//         <Col md={2}>
//           <Form.Label>Flat</Form.Label>
//           <Form.Control
//             placeholder="e.g., A-302"
//             value={form.flatLabel}
//             onChange={(e) =>
//               setForm((s) => ({ ...s, flatLabel: e.target.value }))
//             }
//           />
//         </Col>
//         <Col md={2}>
//           <Form.Label>Type</Form.Label>
//           <Form.Select
//             value={form.visitorType}
//             onChange={(e) =>
//               setForm((s) => ({ ...s, visitorType: e.target.value }))
//             }
//           >
//             <option value="delivery">Delivery</option>
//             <option value="guest">Guest</option>
//             <option value="service">Service</option>
//             <option value="cab">Cab</option>
//             <option value="other">Other</option>
//           </Form.Select>
//         </Col>
//         <Col md={3}>
//           <Form.Label>Visitor Name</Form.Label>
//           <Form.Control
//             value={form.visitorName}
//             onChange={(e) =>
//               setForm((s) => ({ ...s, visitorName: e.target.value }))
//             }
//           />
//         </Col>
//         <Col md={2}>
//           <Form.Label>Phone</Form.Label>
//           <Form.Control
//             value={form.phone}
//             onChange={(e) => setForm((s) => ({ ...s, phone: e.target.value }))}
//           />
//         </Col>
//         <Col md={3}>
//           <Form.Label>Vehicle</Form.Label>
//           <Form.Control
//             value={form.vehicle}
//             onChange={(e) =>
//               setForm((s) => ({ ...s, vehicle: e.target.value }))
//             }
//           />
//         </Col>
//         <Col md={9}>
//           <Form.Label>Purpose</Form.Label>
//           <Form.Control
//             value={form.purpose}
//             onChange={(e) =>
//               setForm((s) => ({ ...s, purpose: e.target.value }))
//             }
//           />
//         </Col>
//         <Col md={3}>
//           <Form.Label>Selfie</Form.Label>
//           <Form.Control
//             type="file"
//             accept="image/*"
//             onChange={(e) =>
//               setForm((s) => ({
//                 ...s,
//                 selfieFile: e.target.files?.[0] || null,
//               }))
//             }
//           />
//         </Col>
//         <Col xs="auto">
//           <Button disabled={submitting || uploading} onClick={onCreate}>
//             {submitting ? "Creating…" : "Create Pending"}
//           </Button>
//         </Col>
//         <Col xs="auto">
//           <Button
//             variant="outline-secondary"
//             onClick={() => setScanOpen((o) => !o)}
//           >
//             {scanOpen ? "Close Scanner" : "Scan QR"}
//           </Button>
//         </Col>
//       </Row>

//       {scanOpen && (
//         <div className="my-3" style={{ maxWidth: 360 }}>
//           {scanError && <Alert variant="warning">{scanError}</Alert>}
//           {/* <QrReader
//             delay={400}
//             onError={(e) => setScanError(e?.message || "Scanner error")}
//             onScan={onScan}
//             style={{ width: "100%" }}
//           /> */}

//           <QrReader
//             constraints={{ facingMode: "environment" }}
//             onResult={(result, error) => {
//               if (!!result) {
//                 onScan(result?.getText?.() || result?.text || "");
//               }
//               if (!!error) {
//                 // You can keep this silent to avoid spamming errors while scanning
//                 // setScanError(error?.message || 'Scanner error');
//               }
//             }}
//             videoStyle={{ width: "100%" }}
//           />
//         </div>
//       )}

//       <hr />

//       <h6>Live Requests</h6>
//       {err && <Alert variant="danger">{err}</Alert>}
//       {loading ? (
//         <Spinner size="sm" />
//       ) : rows.length === 0 ? (
//         <div className="text-muted">No live requests.</div>
//       ) : (
//         <Table size="sm" responsive bordered hover>
//           <thead>
//             <tr>
//               <th>Flat</th>
//               <th>Type</th>
//               <th>Visitor</th>
//               <th>Phone</th>
//               <th>Status</th>
//               <th style={{ width: 280 }}>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {rows.map((r) => (
//               <tr key={r.id}>
//                 <td>{r.flatLabel || "—"}</td>
//                 <td>{r.visitorType}</td>
//                 <td>{r.visitorName}</td>
//                 <td>{r.phone || "—"}</td>
//                 <td>
//                   <Badge bg={STATUS_BADGE[r.status] || "secondary"}>
//                     {r.status}
//                   </Badge>
//                 </td>
//                 <td className="d-flex gap-2 flex-wrap">
//                   {r.status === "approved" && (
//                     <Button size="sm" onClick={() => markEntered(r.id)}>
//                       Mark Entered
//                     </Button>
//                   )}
//                   {r.status === "entered" && (
//                     <Button
//                       size="sm"
//                       variant="warning"
//                       onClick={() => requestExit(r.id)}
//                     >
//                       Request Exit
//                     </Button>
//                   )}
//                   {r.status === "exit_requested" && (
//                     <Button
//                       size="sm"
//                       variant="dark"
//                       onClick={() => markExited(r.id)}
//                     >
//                       Mark Exited
//                     </Button>
//                   )}
//                   {/* Optional: allow override approve/reject by manager here */}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </Table>
//       )}
//     </>
//   );
// }
import React, { useMemo, useRef, useState } from "react";
import {
  Alert,
  Button,
  Col,
  Form,
  Row,
  Spinner,
  Table,
  Badge,
  Modal,
} from "react-bootstrap";
import {
  useVisitorRequests,
  useVisitorActions,
} from "../../hooks/useVisitorRequests";
import { useUploadSelfie } from "../../hooks/useVisitorUploadSelfie";
import { serverTimestamp } from "firebase/firestore";
import { QrReader } from "react-qr-reader";

const STATUS_BADGE = {
  preapproved: "info",
  pending: "secondary",
  approved: "success",
  rejected: "danger",
  entered: "primary",
  exit_requested: "warning",
  exited: "dark",
};

export default function SecurityGatePanel({ community, currentUser }) {
  // ---- Data ----
  // Quickstart: no composite index requirement; adjust when you add filters/sorting
  const { rows, loading, err } = useVisitorRequests({
    communityId: community.id,
    quickStart: true,
    // Recommended later:
    // statusIn: ['pending','approved','preapproved','entered','exit_requested'],
    // orderByCreatedDesc: true,
    // quickStart: false
  });

  const { createRequest, updateRequest, getByQrToken } = useVisitorActions();
  const { uploadSelfie, uploading } = useUploadSelfie();

  // ---- Scan state ----
  const [scanOpen, setScanOpen] = useState(false);
  const [scanError, setScanError] = useState("");
  const lastScanRef = useRef({ token: "", at: 0 });

  // ---- Entry (after scan or from table) ----
  const [selected, setSelected] = useState(null);
  const [entrySelfie, setEntrySelfie] = useState(null);

  // ---- Exit modal ----
  const [exitDlg, setExitDlg] = useState({ open: false, id: null });
  const [exitSelfie, setExitSelfie] = useState(null);
  const [acting, setActing] = useState(false);

  // ---- Quick Create (security creates pending request) ----
  const [qcOpen, setQcOpen] = useState(false);
  const [creating, setCreating] = useState(false);
  const [qc, setQc] = useState({
    flatLabel: "",
    visitorType: "delivery",
    visitorName: "",
    phone: "",
    vehicle: "",
    purpose: "",
    selfieFile: null,
  });
  const qcValid = useMemo(
    () => qc.flatLabel.trim() && qc.visitorName.trim(),
    [qc.flatLabel, qc.visitorName],
  );

  // ---------- Helpers ----------
  const extractToken = (str = "") => {
    try {
      if (!str) return "";
      if (str.includes("/visit/")) {
        return str.split("/visit/")[1].split(/[?#]/)[0];
      }
      if (str.startsWith("VT-")) return str;
      return "";
    } catch {
      return "";
    }
  };

  const shouldThrottleToken = (token) => {
    const now = Date.now();
    if (
      lastScanRef.current.token === token &&
      now - lastScanRef.current.at < 2500
    ) {
      return true; // ignore rapid repeats
    }
    lastScanRef.current = { token, at: now };
    return false;
  };

  const onScanResult = async (result, error) => {
    if (!result) return;
    const text = result?.getText?.() || result?.text || "";
    const token = extractToken(text);
    if (!token) return setScanError("Invalid QR");

    if (shouldThrottleToken(token)) return;

    try {
      const req = await getByQrToken(token);
      if (!req) return setScanError("No request found for this QR");

      // Community guard
      if (req.communityId !== community.id) {
        return setScanError("QR belongs to a different community");
      }
      // Expiry guard (for preapproved resident passes)
      const exp =
        req.qrExpiresAt?.toMillis?.() ??
        (req.qrExpiresAt?._seconds ? req.qrExpiresAt._seconds * 1000 : null);
      if (exp && exp < Date.now()) {
        return setScanError("This QR has expired");
      }

      setSelected(req);
      setScanOpen(false);
      setScanError("");
    } catch (e) {
      setScanError(e?.message || "Scan failed");
    }
  };

  // ---------- Actions ----------
  const attachSelfieAndEnter = async () => {
    if (!selected?.id) return;
    setActing(true);
    try {
      // Optional selfie at entry
      if (entrySelfie) {
        const selfieUrl = await uploadSelfie(entrySelfie, selected.id);
        if (selfieUrl) {
          await updateRequest(selected.id, { selfieUrl });
        }
      }
      await updateRequest(selected.id, {
        status: "entered",
        "gate.entryAt": serverTimestamp(),
        "gate.entryBy": currentUser?.uid || null,
      });
      setSelected(null);
      setEntrySelfie(null);
    } finally {
      setActing(false);
    }
  };

  const requestExit = async (id) => {
    await updateRequest(id, {
      status: "exit_requested",
      "gate.exitRequestedAt": serverTimestamp(),
      "gate.exitRequestedBy": currentUser?.uid || null,
    });
  };

  const openExitDialog = (id) => {
    setExitDlg({ open: true, id });
    setExitSelfie(null);
  };

  const markExited = async () => {
    if (!exitDlg.id) return;
    setActing(true);
    try {
      // Optional exit selfie
      if (exitSelfie) {
        const exitUrl = await uploadSelfie(exitSelfie, exitDlg.id);
        if (exitUrl) {
          await updateRequest(exitDlg.id, { "gate.exitSelfieUrl": exitUrl });
        }
      }
      await updateRequest(exitDlg.id, {
        status: "exited",
        "gate.exitApprovedAt": serverTimestamp(),
        "gate.exitApprovedBy": currentUser?.uid || null,
      });
      setExitDlg({ open: false, id: null });
      setExitSelfie(null);
    } finally {
      setActing(false);
    }
  };

  const onQuickCreate = async () => {
    if (!qcValid) return;
    setCreating(true);
    try {
      const id = await createRequest({
        communityId: community.id,
        flatLabel: qc.flatLabel.trim(),
        visitorType: qc.visitorType,
        visitorName: qc.visitorName.trim(),
        phone: qc.phone.trim(),
        vehicle: qc.vehicle.trim(),
        purpose: qc.purpose.trim(),
        createdBy: {
          uid: currentUser?.uid || null,
          role: "security",
          method: "security-form",
        },
        status: "pending",
        approval: { requestedAt: serverTimestamp() },
      });

      if (qc.selfieFile) {
        const url = await uploadSelfie(qc.selfieFile, id);
        if (url) await updateRequest(id, { selfieUrl: url });
      }

      setQc({
        flatLabel: "",
        visitorType: "delivery",
        visitorName: "",
        phone: "",
        vehicle: "",
        purpose: "",
        selfieFile: null,
      });
      setQcOpen(false);
    } finally {
      setCreating(false);
    }
  };

  // ---------- UI ----------
  return (
    <>
      <h5 className="mb-3">Security Gate</h5>

      <div className="d-flex gap-2 mb-3 flex-wrap">
        <Button
          variant="outline-secondary"
          onClick={() => {
            setScanOpen((o) => !o);
            setScanError("");
          }}
        >
          {scanOpen ? "Close Scanner" : "Scan QR"}
        </Button>

        <Button variant="outline-primary" onClick={() => setQcOpen(true)}>
          New Walk‑In (Quick Create)
        </Button>
      </div>

      {scanOpen && (
        <div className="my-3" style={{ maxWidth: 360 }}>
          {scanError && <Alert variant="warning">{scanError}</Alert>}
          <QrReader
            constraints={{ facingMode: "environment" }}
            onResult={onScanResult}
            videoStyle={{ width: "100%" }}
          />
        </div>
      )}

      {selected && (
        <div className="border rounded p-3 my-3">
          <div className="fw-semibold mb-2">Scanned Request</div>
          <div>
            <strong>Visitor:</strong> {selected.visitorName} •{" "}
            <strong>Flat:</strong> {selected.flatLabel} •{" "}
            <strong>Status:</strong>{" "}
            <span
              className={`badge bg-${STATUS_BADGE[selected.status] || "secondary"}`}
            >
              {selected.status}
            </span>
          </div>

          <div className="mt-3 d-flex align-items-end gap-2 flex-wrap">
            <div style={{ minWidth: 220 }}>
              <Form.Label>Capture Selfie (at entry)</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e) => setEntrySelfie(e.target.files?.[0] || null)}
              />
            </div>
            <Button
              disabled={uploading || acting}
              onClick={attachSelfieAndEnter}
            >
              {acting ? "Updating…" : "Attach & Mark Entered"}
            </Button>
            <Button
              variant="outline-secondary"
              onClick={() => {
                setSelected(null);
                setEntrySelfie(null);
              }}
            >
              Cancel
            </Button>
          </div>
        </div>
      )}

      <hr />

      <h6>Live Requests</h6>
      {err && <Alert variant="danger">{err}</Alert>}

      {loading ? (
        <Spinner size="sm" />
      ) : rows.length === 0 ? (
        <div className="text-muted">No requests yet.</div>
      ) : (
        <Table size="sm" responsive bordered hover className="align-middle">
          <thead>
            <tr>
              <th>Flat</th>
              <th>Type</th>
              <th>Visitor</th>
              <th>Phone</th>
              <th>Status</th>
              <th style={{ width: 360 }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td>{r.flatLabel || "—"}</td>
                <td>{r.visitorType}</td>
                <td>{r.visitorName}</td>
                <td>{r.phone || "—"}</td>
                <td>
                  <Badge bg={STATUS_BADGE[r.status] || "secondary"}>
                    {r.status}
                  </Badge>
                </td>
                <td className="d-flex gap-2 flex-wrap">
                  {(r.status === "approved" || r.status === "preapproved") && (
                    <Button size="sm" onClick={() => setSelected(r)}>
                      Mark Entered (attach selfie)
                    </Button>
                  )}
                  {r.status === "entered" && (
                    <Button
                      size="sm"
                      variant="warning"
                      onClick={() => requestExit(r.id)}
                    >
                      Request Exit
                    </Button>
                  )}
                  {r.status === "exit_requested" && (
                    <Button
                      size="sm"
                      variant="dark"
                      onClick={() => openExitDialog(r.id)}
                    >
                      Mark Exited
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      {/* Quick Create Modal */}
      <Modal show={qcOpen} onHide={() => setQcOpen(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>New Walk‑In Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="g-2">
            <Col md={4}>
              <Form.Label>Flat</Form.Label>
              <Form.Control
                placeholder="e.g., A-302"
                value={qc.flatLabel}
                onChange={(e) =>
                  setQc((s) => ({ ...s, flatLabel: e.target.value }))
                }
              />
            </Col>
            <Col md={4}>
              <Form.Label>Type</Form.Label>
              <Form.Select
                value={qc.visitorType}
                onChange={(e) =>
                  setQc((s) => ({ ...s, visitorType: e.target.value }))
                }
              >
                <option value="delivery">Delivery</option>
                <option value="guest">Guest</option>
                <option value="service">Service</option>
                <option value="cab">Cab</option>
                <option value="other">Other</option>
              </Form.Select>
            </Col>
            <Col md={4}>
              <Form.Label>Visitor Name</Form.Label>
              <Form.Control
                value={qc.visitorName}
                onChange={(e) =>
                  setQc((s) => ({ ...s, visitorName: e.target.value }))
                }
              />
            </Col>
            <Col md={4}>
              <Form.Label>Phone</Form.Label>
              <Form.Control
                value={qc.phone}
                onChange={(e) =>
                  setQc((s) => ({ ...s, phone: e.target.value }))
                }
              />
            </Col>
            <Col md={4}>
              <Form.Label>Vehicle</Form.Label>
              <Form.Control
                value={qc.vehicle}
                onChange={(e) =>
                  setQc((s) => ({ ...s, vehicle: e.target.value }))
                }
              />
            </Col>
            <Col md={12}>
              <Form.Label>Purpose</Form.Label>
              <Form.Control
                value={qc.purpose}
                onChange={(e) =>
                  setQc((s) => ({ ...s, purpose: e.target.value }))
                }
              />
            </Col>
            <Col md={12}>
              <Form.Label>Selfie (optional)</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e) =>
                  setQc((s) => ({
                    ...s,
                    selfieFile: e.target.files?.[0] || null,
                  }))
                }
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => setQcOpen(false)}>
            Cancel
          </Button>
          <Button
            disabled={!qcValid || creating || uploading}
            onClick={onQuickCreate}
          >
            {creating ? "Creating…" : "Create Pending"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Exit Modal */}
      <Modal
        show={exitDlg.open}
        onHide={() => setExitDlg({ open: false, id: null })}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Mark Exited</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-2 text-muted small">
            Optional: capture an exit selfie for audit trail.
          </div>
          <Form.Control
            type="file"
            accept="image/*"
            onChange={(e) => setExitSelfie(e.target.files?.[0] || null)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() => setExitDlg({ open: false, id: null })}
          >
            Cancel
          </Button>
          <Button
            disabled={acting || uploading}
            variant="dark"
            onClick={markExited}
          >
            {acting ? "Updating…" : "Mark Exited"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
